<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-17 16:10:05
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-08-05 16:34:47
-->
<!-- banner -->
<template>
    <div class="bannerBox">
        <div class="banner_content">
            <div class="content_box">
                <div class="banner_left">
                    <div class="banner_title">
                        <span>企业</span>数智化
                    </div>
                    <div class="banner_info">
                        作为企业与服务的高效连接器，通过SAAS云平台为企业数智化转型赋能，实现无限应用服务。
                    </div>
                </div>
                <div class="banner_right">
                </div>
            </div>
        </div>
        <div class="userServeBox">
            <div class="user_block">
                <div class="user_content">
                    <div class="uesr_icon">
                    </div>
                    <div class="uesr_info_box">
                        <p class="uesr_title">面向用户</p>
                        <p class="user_info">中小微企业 <span>|</span> 个体工商户</p>
                    </div>
                </div>
                <div class="user_content">
                    <div class="sever_icon">
                    </div>
                    <div class="uesr_info_box">
                        <p class="uesr_title">服务类型</p>
                        <p class="user_info">财税管理 <span>|</span> 协同办公 <span>|</span> 客户关系 <span>|</span> 咨询服务</p>
                    </div>
                </div>
                <div class="user_content">
                    <div class="busness_icon">
                    </div>
                    <div class="uesr_info_box">
                        <p class="uesr_title">业务优势</p>
                        <p class="user_info">深厚沉淀 <span>|</span> 前沿引领 <span>|</span> 专业精深 <span>|</span> 保障安心</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>
<style scoped lang="scss">
.bannerBox {
  width: 100%;
  height: 580px;
  background: url('../../../assets/image/home/banner_BG.png');
  overflow: hidden;

  .banner_content {
    width: 1200px;
    margin: 0 auto;
    position: relative;

    .content_box {
      display: flex;
      justify-content: space-between;

      .banner_left {
        text-align: left;
        margin-top: 128px;

        .banner_title {
          font-weight: 800;
          line-height: 84px;
          font-size: 50px;
          color: #1a1a1a;

          span {
            color: #be1a21;
          }
        }

        .banner_info {
          margin-top: 34px;
          font-size: 20px;
          font-weight: 400;
          color: #3d3d3d;
          line-height: 42px;
        }
      }

      .banner_right {
        width: 1034px;
        height: 560px;
        margin-top: 22px;
        background: url('../../../assets/image/home/banner_right.png');
        background-size: 100% 100%;
        flex: 0 0 1034px;
        margin-right: -269px;
      }
    }
  }

  .userServeBox {
    margin: 0 auto;
    position: absolute;
    width: 1200px;
    height: 150px;
    background: linear-gradient(180deg, #fffdfd 7%, #ffffff 100%);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    left: 50%;
    margin-left: -600px;
    top: 611px;

    .user_block {
      display: flex;
      justify-content: space-between;
      padding: 42px 44px;

      .user_content {
        display: flex;
        align-items: center;
        text-align: left;
      }

      .uesr_info_box {
        font-family: Alibaba PuHuiTi 2-85 Bold, Alibaba PuHuiTi 20;
        .uesr_title {
          font-size: 20px;
          font-weight: 700;
          color: #4a4a4a;
          line-height: 28px;
          margin-bottom: 9px;
        }

        .user_info {
          font-size: 14px;
          font-weight: 400;
          color: #767676;
          line-height: 20px;
          span {
            margin: 0 4px;
          }
        }
      }

      .uesr_icon,
      .sever_icon,
      .busness_icon {
        // width: 66px;
        // height: 66px;
        margin-right: 11px;
      }

      .uesr_icon {
        width: 66px;
        height: 68px;
        background: url('../../../assets/image/home/user_oriented.png') no-repeat;
        background-size: 100% 100%;
      }

      .sever_icon {
        width: 71px;
        height: 67px;
        background: url('../../../assets/image/home/sever_type.png') no-repeat;
        background-size: 100% 100%;
      }

      .busness_icon {
        width: 78px;
        height: 66px;
        background: url('../../../assets/image/home/business_advantage.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
